import { render, staticRenderFns } from "./articles-panel.vue?vue&type=template&id=db334a36"
import script from "./articles-panel.vue?vue&type=script&lang=js"
export * from "./articles-panel.vue?vue&type=script&lang=js"
import style0 from "./articles-panel.vue?vue&type=style&index=0&id=db334a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports